import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { CartProvider } from "@/lib/cart";
import { getConfig } from "@/lib/api";

import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderSuccessPage from "@/pages/OrderSuccessPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import AdminPage from "@/pages/AdminPage";
import ReferralPage from "@/pages/ReferralPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function AppShell() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    getConfig().then(setConfig).catch(() => {});
  }, []);

  const location = useLocation();
  const hideChrome = location.pathname.startsWith("/admin");

  useEffect(() => {
    const ref = new URLSearchParams(location.search).get("ref");
    if (ref) localStorage.setItem("obrasafe_ref", ref.toUpperCase());
  }, [location.search]);

  return (
    <div className="App min-h-screen bg-[#0a0a0a]">
      {!hideChrome && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:slug" element={<ProductDetailPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order/success" element={<OrderSuccessPage />} />
          <Route path="/contact" element={<ContactPage config={config} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/refer" element={<ReferralPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
      {!hideChrome && <Footer config={config} />}
      {!hideChrome && (
        <WhatsAppButton phone={config?.whatsapp_phone || "233592208031"} />
      )}
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AppShell />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
